const style = {
  marginLeft: 5,
  marginBottom: 5,
  fontSize: 24,
  fontWeight: 700
};

export function SettingTitle(props) {
  return (<>
    <span style={ style }>{ props.text }</span>
  </>);
}
